export const EMAIL_MODAL_LABELS: Record<string, string> = {
  closingCalendarEsign: 'Closing Calendar — E-sign verification',
  addNoteNotification: 'Servicing / Global notes — email notification',
  loanDetailValidation: 'Loan intake — loan detail validation',
  orderAppraisalInformation: 'Order appraisal — send email',
  purchaseAdviceSellerConfirmSign: 'Post closing — purchase advice seller confirm sign',
  trustLedgerDocuments: 'Servicing — trust ledger documents',
  drawApprovalToBorrower: 'Servicing — draw approval to borrower',
  exceptionResponse: 'Loan structure — exception response',
  rePriceLoan: 'Loan structure — re-price loan',
  termSheetDialog: 'Loan structure — term sheet',
  declineLoanChangeRequest: 'Loan structure — decline loan change request',
  loanOptionProceedConfirm: 'Loan structure — loan option proceed confirm',
  reviewLock: 'Loan structure — review lock',
  companyBroadcast: 'Manage accounts — company broadcast',
  communicationSendMessage: 'Communication — send message (investor notify)',
  sendEmailLoanIntakeDocument: 'Loan intake — send document email',
  sendEmailServicingDocument: 'Servicing — send document email',
  sendEmailLoanExtension: 'Servicing — loan extension email',
  sendEmailReoDocument: 'REO — send document email',
  sendEmailOrderOut: 'Order Out — send document email',
  markTask: 'Tasks — mark task / notification',
  loanSubmissionSendPdfEmail: 'Loan submission — send PDF on email',
  netFundingSheetEmail: 'Closing — Net Funding Sheet email',
}

export type EmailModalId = keyof typeof EMAIL_MODAL_LABELS
